import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import useImagesQuery from '../../hooks/useImagesQuery'
import useGatsbyImagesQuery from '../../hooks/useGatsbyImagesQuery'

const setImageObject = (allImages, imageName) => {
  return allImages.find(item => item.name === imageName)
}

const checkImg = (allImages, imageName) => {
  if (allImages.find(item => item.name === imageName)) {
    return true
  }
}

const checkName = src => {
  if (src.split(/\/(?=[^\/]+$)/)[1]) {
    return src.split(/\/(?=[^\/]+$)/)[1]
  }
  return src
}

const Image = ({ src, className }) => {
  const images = useImagesQuery()
  const gatsbyImages = useGatsbyImagesQuery()
  const imageName = checkName(src).split(/\.(?=[^\.]+$)/)[0]
  const imageNameFull = checkName(src)
    .split(/\.(?=[^\.]+$)/)
    .join('.')
  const currentGatsbyImage = gatsbyImages.find(
    image => image.fluid.originalName === imageNameFull
  )
  return currentGatsbyImage ? (
    <Img fluid={currentGatsbyImage.fluid} className={className} />
  ) : (
    <img
      src={
        checkImg(images, imageName)
          ? setImageObject(images, imageName).publicURL
          : src
      }
      alt={
        checkImg(images, imageName)
          ? setImageObject(images, imageName).name
          : imageName.split(/\.(?=[^\.]+$)/)[0]
      }
      className={className}
    />
  )
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string
}

Image.defaultProps = {
  className: ''
}

export default Image
